import type { AxiosResponse } from "axios";
import type BackOfficeConnector from "data/backOfficeConnector";
import type EventBus from "services/eventBus";
import RepositoryBase from "./repositoryBase";

export default class AccountingRepository extends RepositoryBase<BackOfficeConnector> {
  constructor(protected apiFactory: ReturnType<typeof BackOfficeConnector.Factory>, protected eventBus: EventBus) {
    super(apiFactory, eventBus);
  }

  async templates(): Promise<AxiosResponse<File>> {
    return this.callApi(api => api.all("finance").all("accounting").all("templates").getRaw() as any);
  }
}
